// extracted by mini-css-extract-plugin
export default {"role-feature-table":"PermissionRoleList_role-feature-table__qqSdQ"};